// Lib
import { classicFormatMaxTwoDigits } from '@/utils/hooks/format/useFormatNumber';

import { SIZE_50 } from '@/lib/gridElements/size';
import { INSTAGRAM } from '@/lib/socialProfile';

// Components
import { LineChart } from '@/components/composite/Charts/LineChart';

export const sharesHistoryConfig = {
    title: 'chart.instagram.shares_history',
    margin: { left: -10, right: 25 },
    name: {
        date: 'date',
        value: 'chart.instagram.shares_history_name',
        avg: 'chart.instagram.shares_history_avg'
    },
    id: 'shares_history',
    social: INSTAGRAM,
    color: {
        value: 'blue',
        avg: 'gray'
    },
    tooltipTranslation: {
        token: 'chart.facebook.tooltip_history',
        values: ['date', 'value', 'percentage_evolution']
    },
    tooltip: 'chart.instagram.tooltip_shares_history',
    valueFormat: classicFormatMaxTwoDigits,
    size: SIZE_50,
    type: 'chart',
    element: LineChart
};
